import {
  ISMOBILEPHONE_CHANGED,
  ISTABLET_CHANGED
} from './initial-app-state-const';

export function changeIsMobilePhone(newValue) {
  return {
    type: ISMOBILEPHONE_CHANGED,
    payload: {
      isMobilePhone: newValue
    }
  };
}

export function changeIsTablet(isTablet) {
  return {
    type: ISTABLET_CHANGED,
    payload: {
      isTablet: isTablet
    }
  };
}




/** WEBPACK FOOTER **
 ** app/components/initial-app-state/state/initial-app-state-actions.js
 **/